










import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class NnnFooter extends Vue {

  get year() {
    return new Date().getFullYear();
  }
}
